import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, setTokenLoyalty } from 'functions';
import { LINK_DEV } from 'constants/index';
import { rqGetTokenLoyalty } from 'model/services/LoginService';
import { handleLogout } from 'model/constants/variableConstant';

function PrivateRoute({ isAuthRoute = false, component }) {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  const getToken = async () => {
    if (location.pathname === '/' && !!location.search && !!location.search.split('?token=')[1]) {
      const data = await rqGetTokenLoyalty();
      setTokenLoyalty(data.obj);

      navigate('/pages/loyalty-store');
      return;
    }
    if (location.pathname === '/') {
      navigate('/pages/loyalty-store');
    }
  };
  useEffect(() => {
    getToken();
  }, []);

  return component;
}

export default PrivateRoute;
